import { render } from "./IAmPublicSpeaker.vue?vue&type=template&id=eba0dc54"
import script from "./IAmPublicSpeaker.vue?vue&type=script&lang=js"
export * from "./IAmPublicSpeaker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__